import React from 'react';

export const OfflineBanner: React.FC = () => (
  <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500/90 backdrop-blur-sm px-4 py-2 text-center text-sm font-medium text-black">
    You&apos;re offline &mdash; showing cached data
  </div>
);
